import React from 'react';
import {
  Form, Row, Col, Input, Select, Button, InputNumber,Icon
} from 'antd';
import MiCompAPI from '../../util/api';
import img from './../../assets/img/Illustration.png';
const { Option } = Select;
class FD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
           this.props.submitHandler({ ...values, id: 0 },(val)=>{
             if(!val){

             }
        });
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      isValueExists:true,
    }
    this.api = new MiCompAPI(null);
  }
  handleChange = (e) => {
    if (e.target.value && e.target.value.length > 1) {
      this.api.invoke("IsValueExists/STATE/" + e.target.value + "/ABBR", "get", (data, success) => {
        if (success) {
          this.setState({ isValueExists: data.data });
        }
      });
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    let { act_types } = this.props;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18} >
            <p style={{marginLeft:"14px"}} className='mi_title'>{this.props.title}</p>
          </Col>
          <Col span={6}>
          <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{color:'red'}} onClick={this.props.closeDrawerHandler} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Account Type</legend>
                  {getFieldDecorator('account_Type_Id', {
                    rules: [{ required: true, message: <span style={{marginTop:'-6px !important'}}> Please select an account type. </span>}],
                  })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input" placeholder="Please Select Account Type *">
                    {act_types.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                  </Select>)}
              </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Account Holder Name</legend>
                  {getFieldDecorator('Acc_Holder_Name', {
                    rules: [{ required: true, message: 'Please enter Account Holder Name.' },{
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets"
                    }],
                  })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder='Account Holder Name *' />)}
              </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Account Number</legend>
                  {getFieldDecorator('acc_Number', {
                    rules: [{ required: true, message: 'Please enter Account Number details.' },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
                      message: "It allows only Alphabets"
                    }],
                  })(<InputNumber autoComplete={"nope"}  className="mi_input" type="text" placeholder='Account Number *' />)}
              </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
            <Form.Item>
            <fieldset className="mi_input_pop">
                <legend className="legend-font">State Code</legend>
                  {getFieldDecorator('country_Code', {
                    rules: [{ required: true, message: 'Please enter State Code.' },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Z]{2,2}$/,
                      message: "Value should be 2 character and Capital letters only(A-Z)",
                    }],
                  })(<Input autoComplete={"nope"}   maxLength="2" className="mi_input" type="text" onChange={this.handleChange} placeholder='State Code *'/>)}
              </fieldset>
              </Form.Item>
              {!this.state.isValueExists ? <p style={{ color: "red", marginLeft: '10px' }}>State Code Not Valid</p> : ""}
            </Col>
          </Row>
         <Row span={24}>
         <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Primary Account</legend>                  {getFieldDecorator('isprimaryAcc', {
                    rules: [{ required: true, message: <span style={{marginTop:'-6px !important'}}> Please select a Primary Account. </span>}],
                  })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input" placeholder="Is it Primary Account*">
                    <Option value={true} key={true}>Yes</Option>
                    <Option value={false} key={true}>No</Option>
                  </Select>)}
              </fieldset>
              </Form.Item>
            </Col>
         </Row>
          <Row span={24} style={{ marginTop:'20px'}}>
            <Col span={7} ></Col>
            <Col span={5} >
              <Button className="mi_button_right submit-button" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                Cancel
                        </Button>
            </Col>
            <Col span={5} >
              <Button htmlType="submit"  className="submit-button" type="primary" >
                Submit
                    </Button>
            </Col>
            <Col span={7} >
            <img alt="example" style={{ width: 105,marginBottom:'-28px',float:'right' }} src={img} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const AddAccountDrawer = Form.create()(FD);
export default AddAccountDrawer;